var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "new-journal"
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('Header'), _c('div', {
    staticClass: "_profile-page"
  }, [_c('div', {
    staticClass: "_profile-container"
  }, [_c('ColumnSettings', {
    attrs: {
      "mode": _vm.mode
    }
  }), _vm.mode !== 'default' ? [_c('aside', {
    staticClass: "_profile-mode-column"
  }, [_vm.mode === 'change-payment-type' ? [_c('div', {
    staticClass: "_profile-mode-inner"
  }, [_vm._m(0), _c('div', {
    staticClass: "_profile-payments-wrapper"
  }, [_c('div', {
    staticClass: "_profile-payments"
  }, [_c('div', {
    staticClass: "_profile-payment _profile-payment-mobile",
    on: {
      "click": _vm.activateTele2
    }
  }, [_vm.user.payment.method !== 'tele2' || _vm.user.payment.type !== 1 && _vm.user.payment.type !== 2 ? [_vm._m(1)] : [_vm._m(2)]], 2), _c('div', {
    staticClass: "_profile-payment _profile-payment-card",
    on: {
      "click": _vm.yaPay
    }
  }, [_vm.user.payment.method !== 'card' || _vm.user.payment.type !== 1 && _vm.user.payment.type !== 2 ? [_vm._m(3)] : [_vm._m(4)]], 2)]), !_vm.passwordChangeSuccess && !_vm.emailChangeSuccess && _vm.mode !== 'subscription-canceled' ? _c('a', {
    staticClass: "_profile-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.mode = 'default';
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/lk-mode-back.svg")
    }
  }), _c('p', [_vm._v("Вернуться")])]) : _vm._e()])])] : _vm._e(), _vm.mode === 'change-password' ? [_vm.passwordChangeSuccess ? [_c('div', {
    staticClass: "_profile-mode-inner-success"
  }, [_vm._m(5), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Закрыть"
    },
    on: {
      "buttonAction": _vm.goDefaultProfile
    }
  })], 1)] : [_c('div', {
    staticClass: "_profile-mode-inner change-pass"
  }, [_vm._m(6), _c('form', {
    staticClass: "enter-form",
    class: {
      'enter-form-error': _vm.passwordChangeError
    },
    attrs: {
      "method": "post",
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "_profile-mode-input-group"
  }, [_c('label', {
    staticClass: "_profile-mode-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm.passwordChangeError.message === 'Пароли не совпадают' ? _c('span', [_vm._v(" Пароли не совпадают ")]) : _vm.passwordChangeError.message === 'Пароль менее 6 символов' ? _c('span', [_vm._v("Пароль менее 6 символов")]) : _c('span', [_vm._v("Введите новый пароль")])]), _c('InputHideShow', {
    attrs: {
      "hasError": _vm.passwordChangeError
    },
    on: {
      "setPass": _vm.setPass
    }
  })], 1), _c('div', {
    staticClass: "_profile-mode-input-group mb42"
  }, [_c('label', {
    staticClass: "_profile-mode-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm.passwordChangeError.message === 'Пароли не совпадают' ? _c('span', [_vm._v(" Пароли не совпадают ")]) : _vm.passwordChangeError.message === 'Пароль менее 6 символов' ? _c('span', [_vm._v("Пароль менее 6 символов")]) : _c('span', [_vm._v("Введите новый пароль еще раз")])]), _c('InputHideShow', {
    attrs: {
      "hasError": _vm.passwordChangeError
    },
    on: {
      "setPass": _vm.setPassConfirm
    }
  })], 1), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": _vm.passwordChangeError.btn
    },
    on: {
      "buttonAction": _vm.changePassword
    }
  }), !_vm.passwordChangeSuccess && !_vm.emailChangeSuccess && _vm.mode !== 'subscription-canceled' ? _c('a', {
    staticClass: "_profile-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.mode = 'default';
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/lk-mode-back.svg")
    }
  }), _c('p', [_vm._v("Вернуться")])]) : _vm._e()], 1)])]] : _vm._e(), _vm.mode === 'email-control' ? [_vm.emailChangeSuccess ? [_c('div', {
    staticClass: "_profile-mode-inner-success"
  }, [_vm._m(7), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Закрыть"
    },
    on: {
      "buttonAction": _vm.goDefaultProfile
    }
  })], 1)] : [_c('div', {
    staticClass: "_profile-mode-inner email-control"
  }, [_vm._m(8), _c('form', {
    staticClass: "enter-form",
    class: {
      'enter-form-error': _vm.emailChangeError
    },
    attrs: {
      "method": "post",
      "autocomplete": "off"
    }
  }, [_c('a', {
    staticClass: "_profile-go-to-mail",
    attrs: {
      "target": "_blank",
      "href": _vm.emailLink
    }
  }, [_vm._m(9)]), _c('div', {
    staticClass: "_profile-mode-input-group"
  }, [_c('label', {
    staticClass: "_profile-mode-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm.emailChangeError.message === 'E-mail не совпадает' ? _c('span', [_vm._v(" E-mail не совпадает ")]) : _vm.emailChangeError.message === 'Некорректный e-mail' ? _c('span', [_vm._v(" Некорректный e-mail ")]) : _c('span', [_vm._v("Задайте новый e-mail")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newEmail,
      expression: "newEmail"
    }],
    staticClass: "_profile-mode-input",
    attrs: {
      "placeholder": "Ваш E-mail",
      "type": "text",
      "name": "email_q"
    },
    domProps: {
      "value": _vm.newEmail
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "_profile-mode-input-group mb22"
  }, [_c('label', {
    staticClass: "_profile-mode-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm.emailChangeError.message === 'E-mail не совпадает' ? _c('span', [_vm._v(" E-mail не совпадает ")]) : _vm.emailChangeError.message === 'Некорректный e-mail' ? _c('span', [_vm._v(" Некорректный e-mail ")]) : _c('span', [_vm._v("Введите новый e-mail еще раз")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newEmailConfirm,
      expression: "newEmailConfirm"
    }],
    staticClass: "_profile-mode-input",
    attrs: {
      "placeholder": "E-mail еще раз",
      "type": "text",
      "name": "email_s"
    },
    domProps: {
      "value": _vm.newEmailConfirm
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.newEmailConfirm = $event.target.value;
      }
    }
  })]), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": _vm.emailChangeError.btn
    },
    on: {
      "buttonAction": _vm.changeEmail
    }
  }), !_vm.passwordChangeSuccess && !_vm.emailChangeSuccess && _vm.mode !== 'subscription-canceled' ? _c('a', {
    staticClass: "_profile-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.mode = 'default';
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/lk-mode-back.svg")
    }
  }), _c('p', [_vm._v("Вернуться")])]) : _vm._e()], 1)])]] : _vm._e(), _vm.mode === 'confirm-cancel-subscription' ? [_c('div', {
    staticClass: "_profile-mode-inner cancel-sub"
  }, [_vm._m(10), _c('div', {
    staticClass: "_profile-page-mode-form-block"
  }, [_vm._m(11), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Я передумал"
    },
    on: {
      "buttonAction": _vm.goDefaultProfile
    }
  }), _c('ButtonAction', {
    staticClass: "main-action-btn main-action-btn-grey",
    attrs: {
      "type": "submit",
      "message": "Отключить"
    },
    on: {
      "buttonAction": _vm.doCancelSubscription
    }
  })], 1)])] : _vm._e(), _vm.mode === 'confirm-cancel-subscription-inv' ? [_c('div', {
    staticClass: "_profile-mode-inner cancel-sub"
  }, [_vm._m(12), _c('div', {
    staticClass: "_profile-page-mode-form-block"
  }, [_vm._m(13), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Я передумал"
    },
    on: {
      "buttonAction": _vm.goDefaultProfile
    }
  }), _c('ButtonAction', {
    staticClass: "main-action-btn main-action-btn-grey",
    attrs: {
      "type": "submit",
      "message": "Отключить"
    },
    on: {
      "buttonAction": _vm.doCancelSubscriptionInv
    }
  })], 1)])] : _vm._e(), _vm.mode === 'confirm-cancel-all-subscriptions' ? [_c('div', {
    staticClass: "_profile-mode-inner cancel-sub"
  }, [_vm._m(14), _c('div', {
    staticClass: "_profile-page-mode-form-block"
  }, [_vm._m(15), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Я передумал"
    },
    on: {
      "buttonAction": _vm.goDefaultProfile
    }
  }), _c('ButtonAction', {
    staticClass: "main-action-btn main-action-btn-grey",
    attrs: {
      "type": "submit",
      "message": "Отключить все",
      "isLoading": _vm.cancelAllPreload
    },
    on: {
      "buttonAction": _vm.doCancelAllSubscriptions
    }
  })], 1)])] : _vm._e(), _vm.mode === 'subscription-canceled' ? [_c('div', {
    staticClass: "_profile-mode-inner-success"
  }, [_vm._m(16), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Закрыть"
    },
    on: {
      "buttonAction": _vm.goDefaultProfile
    }
  })], 1)] : _vm._e(), _vm.mode === 'yandex-pay-success' ? [_c('div', {
    staticClass: "_profile-mode-inner-success"
  }, [_c('img', {
    staticClass: "_profile-mode-inner-success-image",
    attrs: {
      "src": require("@/assets/img/profile-check.svg"),
      "alt": "Финсайт"
    }
  }), _c('div', {
    staticClass: "_profile-mode-inner-success-title"
  }, [_vm._v(" Оплата прошла успешно ")]), _c('router-link', {
    staticClass: "_profile-btn _profile-btn-gradient",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Перейти к чтению !")]), _vm._m(17), _c('a', {
    staticClass: "_profile-btn _profile-btn-blue",
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "href": "/profile"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.mode = 'default';
        _vm.removeHash();
      }
    }
  }, [_vm._v("Обратно в личный кабинет")])], 1)] : _vm._e()], 2)] : [_c('ColumnSubscriptions', {
    attrs: {
      "mode": _vm.mode
    },
    on: {
      "activateJournalSubscription": _vm.activateTele2,
      "activateInvestSubscription": _vm.activateInvestSubscription
    }
  })], _c('ColumnData', {
    attrs: {
      "mode": _vm.mode
    }
  })], 2)]), _c('Footer')], 1), _c('div', {
    staticClass: "phone"
  }, [_vm.mode === 'default' ? [_c('Header'), _c('div', {
    staticClass: "_profile-page"
  }, [_c('div', {
    staticClass: "_profile-container"
  }, [_c('ColumnSettings', {
    attrs: {
      "mode": _vm.mode
    }
  }), _c('ColumnSubscriptions', {
    attrs: {
      "mode": _vm.mode
    },
    on: {
      "activateJournalSubscription": _vm.activateTele2,
      "activateInvestSubscription": _vm.activateInvestSubscription
    }
  }), _c('ColumnData', {
    attrs: {
      "mode": _vm.mode
    }
  })], 1)]), _c('Footer')] : _vm._e(), _vm.mode !== 'default' ? [_c('div', [_c('div', {
    staticClass: "_profile-wrapper"
  }, [_c('Header', {
    attrs: {
      "mobHasMenu": false
    }
  }), _c('div', {
    staticClass: "container"
  }, [!_vm.passwordChangeSuccess && !_vm.emailChangeSuccess && _vm.mode !== 'subscription-canceled' ? _c('a', {
    staticClass: "_profile-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.mode = 'default';
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/lk-mode-back.svg")
    }
  }), _c('p', [_vm._v("Вернуться")])]) : _vm._e(), _vm.mode === 'change-payment-type' ? [_c('div', {
    staticClass: "_profile-mode-inner"
  }, [_vm._m(18), _c('div', {
    staticClass: "_profile-payments"
  }, [_c('div', {
    staticClass: "_profile-payment _profile-payment-mobile",
    on: {
      "click": _vm.activateTele2
    }
  }, [_vm.user.payment.method !== 'tele2' ? [_vm._m(19)] : [_vm._m(20)]], 2), _c('div', {
    staticClass: "_profile-payment _profile-payment-card",
    on: {
      "click": _vm.yaPay
    }
  }, [_vm.user.payment.method !== 'card' ? [_vm._m(21)] : [_vm._m(22)]], 2)])])] : _vm._e(), _vm.mode === 'change-password' ? [_vm.passwordChangeSuccess ? [_c('div', {
    staticClass: "_profile-mode-inner-success"
  }, [_vm._m(23), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Закрыть"
    },
    on: {
      "buttonAction": _vm.goDefaultProfile
    }
  })], 1)] : [_c('div', {
    staticClass: "_profile-mode-inner change-pass"
  }, [_vm._m(24), _c('form', {
    staticClass: "enter-form",
    class: {
      'enter-form-error': _vm.passwordChangeError
    },
    attrs: {
      "method": "post",
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "_profile-mode-input-group"
  }, [_c('label', {
    staticClass: "_profile-mode-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm.passwordChangeError.message === 'Пароли не совпадают' ? _c('span', [_vm._v(" Пароли не совпадают ")]) : _vm.passwordChangeError.message === 'Пароль менее 6 символов' ? _c('span', [_vm._v("Пароль менее 6 символов")]) : _c('span', [_vm._v("Введите новый пароль")])]), _c('InputHideShow', {
    attrs: {
      "hasError": _vm.passwordChangeError
    },
    on: {
      "setPass": _vm.setPass
    }
  })], 1), _c('div', {
    staticClass: "_profile-mode-input-group mb35"
  }, [_c('label', {
    staticClass: "_profile-mode-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm.passwordChangeError.message === 'Пароли не совпадают' ? _c('span', [_vm._v(" Пароли не совпадают ")]) : _vm.passwordChangeError.message === 'Пароль менее 6 символов' ? _c('span', [_vm._v("Пароль менее 6 символов")]) : _c('span', [_vm._v("Введите новый пароль еще раз")])]), _c('InputHideShow', {
    attrs: {
      "hasError": _vm.passwordChangeError
    },
    on: {
      "setPass": _vm.setPassConfirm
    }
  })], 1), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": _vm.passwordChangeError.btn
    },
    on: {
      "buttonAction": _vm.changePassword
    }
  })], 1)])]] : _vm._e(), _vm.mode === 'email-control' ? [_vm.emailChangeSuccess ? [_c('div', {
    staticClass: "_profile-mode-inner-success"
  }, [_vm._m(25), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Закрыть"
    },
    on: {
      "buttonAction": _vm.goDefaultProfile
    }
  })], 1)] : [_c('div', {
    staticClass: "_profile-mode-inner email-control"
  }, [_vm._m(26), _c('form', {
    staticClass: "enter-form",
    class: {
      'enter-form-error': _vm.emailChangeError
    },
    attrs: {
      "method": "post",
      "autocomplete": "off"
    }
  }, [_c('a', {
    staticClass: "_profile-go-to-mail",
    attrs: {
      "target": "_blank",
      "href": _vm.emailLink
    }
  }, [_vm._m(27)]), _c('div', {
    staticClass: "_profile-mode-input-group"
  }, [_c('label', {
    staticClass: "_profile-mode-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm.emailChangeError.message === 'E-mail не совпадает' ? _c('span', [_vm._v(" E-mail не совпадает ")]) : _vm.emailChangeError.message === 'Некорректный e-mail' ? _c('span', [_vm._v(" Некорректный e-mail ")]) : _c('span', [_vm._v("Задайте новый e-mail")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newEmail,
      expression: "newEmail"
    }],
    staticClass: "_profile-mode-input",
    attrs: {
      "placeholder": "Ваш E-mail",
      "type": "text",
      "name": "email_q"
    },
    domProps: {
      "value": _vm.newEmail
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "_profile-mode-input-group mb35"
  }, [_c('label', {
    staticClass: "_profile-mode-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm.emailChangeError.message === 'E-mail не совпадает' ? _c('span', [_vm._v(" E-mail не совпадает ")]) : _vm.emailChangeError.message === 'Некорректный e-mail' ? _c('span', [_vm._v(" Некорректный e-mail ")]) : _c('span', [_vm._v("Введите новый e-mail еще раз")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newEmailConfirm,
      expression: "newEmailConfirm"
    }],
    staticClass: "_profile-mode-input",
    attrs: {
      "placeholder": "E-mail еще раз",
      "type": "text",
      "name": "email_s"
    },
    domProps: {
      "value": _vm.newEmailConfirm
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.newEmailConfirm = $event.target.value;
      }
    }
  })]), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": _vm.emailChangeError.btn
    },
    on: {
      "buttonAction": _vm.changeEmail
    }
  })], 1)])]] : _vm._e(), _vm.mode === 'confirm-cancel-subscription' ? [_c('div', {
    staticClass: "_profile-mode-inner cancel-sub"
  }, [_vm._m(28), _vm._m(29), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Я передумал"
    },
    on: {
      "buttonAction": _vm.goDefaultProfile
    }
  }), _c('ButtonAction', {
    staticClass: "main-action-btn main-action-btn-grey",
    attrs: {
      "type": "submit",
      "message": "Отключить"
    },
    on: {
      "buttonAction": _vm.doCancelSubscription
    }
  })], 1)] : _vm._e(), _vm.mode === 'confirm-cancel-subscription-inv' ? [_c('div', {
    staticClass: "_profile-mode-inner cancel-sub"
  }, [_vm._m(30), _vm._m(31), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Я передумал"
    },
    on: {
      "buttonAction": _vm.goDefaultProfile
    }
  }), _c('ButtonAction', {
    staticClass: "main-action-btn main-action-btn-grey",
    attrs: {
      "type": "submit",
      "message": "Отключить"
    },
    on: {
      "buttonAction": _vm.doCancelSubscriptionInv
    }
  })], 1)] : _vm._e(), _vm.mode === 'confirm-cancel-all-subscriptions' ? [_c('div', {
    staticClass: "_profile-mode-inner cancel-sub"
  }, [_vm._m(32), _vm._m(33), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Я передумал"
    },
    on: {
      "buttonAction": _vm.goDefaultProfile
    }
  }), _c('ButtonAction', {
    staticClass: "main-action-btn main-action-btn-grey",
    attrs: {
      "type": "submit",
      "message": "Отключить все",
      "isLoading": _vm.cancelAllPreload
    },
    on: {
      "buttonAction": _vm.doCancelAllSubscriptions
    }
  })], 1)] : _vm._e(), _vm.mode === 'subscription-canceled' ? [_c('div', {
    staticClass: "_profile-mode-inner-success"
  }, [_vm._m(34), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Закрыть"
    },
    on: {
      "buttonAction": _vm.goDefaultProfile
    }
  })], 1)] : _vm._e(), _vm.mode === 'change-payment-type1' ? [_c('div', {
    staticClass: "_profile-phone-number-label"
  }, [_vm._v("Ваш номер телефона")]), _c('div', {
    staticClass: "_profile-phone-number"
  }, [_vm._v(_vm._s(_vm.user.phone.formatted))]), _c('div', {
    staticClass: "_profile-payments"
  }, [_c('div', {
    staticClass: "_profile-payment _profile-payment-mobile",
    on: {
      "click": _vm.activateTele2
    }
  }, [_vm.user.payment.method !== 'tele2' ? _c('mobile-gray') : _vm.user.payment.method === 'tele2' ? _c('mobile-active') : _c('mobile'), _c('div', [_vm.user.payment.method !== 'tele2' ? [_c('b', [_vm._v("Оплата с мобильного")]), _vm._m(35)] : [_c('b', [_vm._v("Оплата с мобильного")]), _vm._m(36)]], 2)], 1), _c('div', {
    staticClass: "_profile-payment _profile-payment-card",
    on: {
      "click": _vm.yaPay
    }
  }, [_vm.user.payment.method !== 'card' ? _c('card-gray') : _vm.user.payment.method === 'card' ? _c('card-active') : _c('card'), _c('div', [_vm.user.payment.method !== 'card' ? [_c('b', [_vm._v("Оплата по карте")]), _vm._m(37)] : [_c('b', [_vm._v("Отключить автоплатеж")]), _vm._m(38)]], 2)], 1)]), _c('div', {
    staticClass: "_profile-back"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.mode = 'default';
      }
    }
  }, [_vm._v("Вернуться назад")])])] : _vm._e(), _vm.mode === 'confirm-card-cancel-subscription' ? [_c('div', {
    staticClass: "_profile-mode-inner-success"
  }, [_c('div', {
    staticClass: "_profile-mode-inner-success-title"
  }, [_vm._v(" Уверены, что хотите отвязать карту? ")]), _c('a', {
    staticClass: "_profile-btn _profile-btn-blue",
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.mode = 'change-payment-type';
      }
    }
  }, [_vm._v("Нет, я случайно")]), _c('a', {
    staticClass: "_profile-btn _profile-btn-outline",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.cancelSubscriptionCard($event);
      }
    }
  }, [_vm._v("Да, отвязать")])])] : _vm._e(), _vm.mode === 'subscription-card-canceled' ? [_c('div', {
    staticClass: "_profile-mode-inner-success"
  }, [_c('img', {
    staticClass: "_profile-mode-inner-success-image",
    attrs: {
      "src": require("@/assets/img/heart.svg"),
      "alt": "Финсайт"
    }
  }), _c('div', {
    staticClass: "_profile-mode-inner-success-title"
  }, [_vm._v(" Мы будем ждать тебя обратно! ")]), _c('a', {
    staticClass: "_profile-btn _profile-btn-blue",
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.mode = 'change-payment-type';
      }
    }
  }, [_vm._v("Я передумал!")]), _c('div', {
    staticClass: "___desc",
    staticStyle: {
      "margin-bottom": "60px"
    }
  }, [_vm._v(" Карта успешно отвязана, Подписка действует до конца оплаченного периода ")]), _c('div', {
    staticClass: "_profile-back"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Вернуться на главную страницу")])], 1)])] : _vm._e(), _vm.mode === 'yandex-pay-success' ? [_c('div', {
    staticClass: "_profile-mode-inner-success"
  }, [_c('img', {
    staticClass: "_profile-mode-inner-success-image",
    attrs: {
      "src": require("@/assets/img/profile-check.svg"),
      "alt": "Финсайт"
    }
  }), _c('div', {
    staticClass: "_profile-mode-inner-success-title"
  }, [_vm._v(" Оплата прошла успешно ")]), _c('router-link', {
    staticClass: "_profile-btn _profile-btn-gradient",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Перейти к чтению !")]), _vm._m(39), _c('a', {
    staticClass: "_profile-btn _profile-btn-blue",
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "href": "/profile"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.mode = 'default';
        _vm.removeHash();
      }
    }
  }, [_vm._v("Обратно в личный кабинет")])], 1)] : _vm._e()], 2), _c('Footer', {
    attrs: {
      "onlyCopyright": true
    }
  })], 1)])] : _vm._e()], 2), _vm.paymentSuccessModal ? _c('div', {
    staticClass: "payment-success-modal-overlay",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closePaymentSuccessModal($event);
      }
    }
  }, [_c('div', {
    staticClass: "payment-success-modal"
  }, [_c('span', {
    staticClass: "payment-success-modal-close",
    attrs: {
      "role": "button",
      "tabindex": "0",
      "aria-label": "Закрыть"
    },
    on: {
      "click": _vm.closePaymentSuccessModal,
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.closePaymentSuccessModal($event);
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5 5l10 10M15 5L5 15",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])]), _c('div', {
    staticClass: "payment-success-modal-title"
  }, [_vm._v("Подключение выполнено")]), _vm._m(40)])]) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-page-mode-info"
  }, [_c('h3', {
    staticClass: "_profile-page-mode-title"
  }, [_vm._v("Изменить способ оплаты")]), _c('p', {
    staticClass: "_profile-page-mode-text"
  }, [_vm._v("Выберите новый способ оплаты")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-payment-grey"
  }, [_c('div', {
    staticClass: "_profile-payment-header"
  }, [_c('b', [_vm._v("Оплата с мобильного")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@/assets/img/lk-mode-circle.svg"),
      "alt": "circle"
    }
  })]), _c('img', {
    staticClass: "_profile-payment-img",
    attrs: {
      "src": require("@/assets/img/lk-mode-mobile-grey.svg"),
      "alt": "mobile-grey"
    }
  }), _c('span', [_vm._v("Стоимость: 16р/день")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-payment-green"
  }, [_c('div', {
    staticClass: "_profile-payment-header"
  }, [_c('b', [_vm._v("Оплата с мобильного")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@/assets/img/lk-mode-circle-active.svg"),
      "alt": "circle-active"
    }
  })]), _c('img', {
    staticClass: "_profile-payment-img",
    attrs: {
      "src": require("@/assets/img/lk-mode-mobile-green.svg"),
      "alt": "mobile-green"
    }
  }), _c('span', [_vm._v("Стоимость: 16р/день")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-payment-grey"
  }, [_c('div', {
    staticClass: "_profile-payment-header"
  }, [_c('b', [_vm._v("Оплата"), _c('br'), _vm._v(" по карте")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@/assets/img/lk-mode-circle.svg"),
      "alt": "circle"
    }
  })]), _c('img', {
    staticClass: "_profile-payment-img",
    attrs: {
      "src": require("@/assets/img/lk-mode-credit-card-grey.svg"),
      "alt": "credit-card-grey"
    }
  }), _c('span', [_vm._v("Mastercard/VISA/МИР"), _c('br'), _vm._v("Стоимость: 269р/месяц")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-payment-green"
  }, [_c('div', {
    staticClass: "_profile-payment-header"
  }, [_c('b', [_vm._v("Оплата"), _c('br'), _vm._v(" по карте")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@/assets/img/lk-mode-circle-active.svg"),
      "alt": "circle-active"
    }
  })]), _c('img', {
    staticClass: "_profile-payment-img",
    attrs: {
      "src": require("@/assets/img/lk-mode-credit-card-green.svg"),
      "alt": "credit-card-green"
    }
  }), _c('span', [_vm._v("Mastercard/VISA/МИР"), _c('br'), _vm._v("Стоимость: 269р/месяц")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-mode-inner-success-card"
  }, [_c('img', {
    staticClass: "_profile-mode-inner-success-image",
    attrs: {
      "src": require("@/assets/img/password-change-success.svg"),
      "alt": "Финсайт"
    }
  }), _c('div', {
    staticClass: "_profile-mode-inner-success-title"
  }, [_vm._v(" Пароль "), _c('br'), _vm._v(" успешно изменен! ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-page-mode-info"
  }, [_c('h3', {
    staticClass: "_profile-page-mode-title"
  }, [_vm._v("Изменить пароль")]), _c('p', {
    staticClass: "_profile-page-mode-text"
  }, [_vm._v("Задайте новый пароль не менее 6 символов")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-mode-inner-success-card"
  }, [_c('img', {
    staticClass: "_profile-mode-inner-success-image",
    attrs: {
      "src": require("@/assets/img/password-change-success.svg"),
      "alt": "Финсайт"
    }
  }), _c('div', {
    staticClass: "_profile-mode-inner-success-title"
  }, [_vm._v(" E-mail "), _c('br'), _vm._v(" успешно изменен! ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-page-mode-info"
  }, [_c('h3', {
    staticClass: "_profile-page-mode-title"
  }, [_vm._v("Управление E-mail")]), _c('p', {
    staticClass: "_profile-page-mode-text"
  }, [_vm._v("Для просмотра писем перейдите в почту или добавьте свой e-mail ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "btn-go-to-mail"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/message-icon.svg"),
      "alt": "message"
    }
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v("Перейти в почту")]), _c('img', {
    staticClass: "_profile-nav-arr",
    attrs: {
      "src": require("@/assets/img/lk-menu-arrow.svg"),
      "alt": "arrow"
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-page-mode-info"
  }, [_c('h3', {
    staticClass: "_profile-page-mode-title"
  }, [_vm._v("Отключить услугу")]), _c('p', {
    staticClass: "_profile-page-mode-text"
  }, [_vm._v("В этом случае доступ к разделам приостановится")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h2', {
    staticClass: "_profile-page-mode-confirm-title"
  }, [_vm._v("Вы уверены, что хотите приостановить доступ "), _c('br'), _vm._v("к журналу?")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-page-mode-info"
  }, [_c('h3', {
    staticClass: "_profile-page-mode-title"
  }, [_vm._v("Отключить услугу")]), _c('p', {
    staticClass: "_profile-page-mode-text"
  }, [_vm._v("В этом случае доступ к разделам приостановится")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h2', {
    staticClass: "_profile-page-mode-confirm-title"
  }, [_vm._v("Вы уверены, что хотите приостановить доступ "), _c('br'), _vm._v("к инвестициям?")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-page-mode-info"
  }, [_c('h3', {
    staticClass: "_profile-page-mode-title"
  }, [_vm._v("Отключить все услуги")]), _c('p', {
    staticClass: "_profile-page-mode-text"
  }, [_vm._v("Будут отключены все активные подписки")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h2', {
    staticClass: "_profile-page-mode-confirm-title"
  }, [_vm._v("Вы уверены, что хотите приостановить доступ "), _c('br'), _vm._v("ко всем услугам?")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-mode-inner-success-card"
  }, [_c('img', {
    staticClass: "_profile-mode-inner-success-image",
    attrs: {
      "src": require("@/assets/img/password-change-success.svg"),
      "alt": "Финсайт"
    }
  }), _c('div', {
    staticClass: "_profile-mode-inner-success-title"
  }, [_vm._v(" Услуга "), _c('br'), _vm._v(" успешно отключена! ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "margin-bottom": "23px",
      "margin-top": "31px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/profile-img.svg"),
      "alt": "Финсайт"
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-page-mode-info"
  }, [_c('h3', {
    staticClass: "_profile-page-mode-title"
  }, [_vm._v("Изменить способ оплаты")]), _c('p', {
    staticClass: "_profile-page-mode-text"
  }, [_vm._v("Выберите новый способ оплаты")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-payment-grey"
  }, [_c('div', {
    staticClass: "_profile-payment-header"
  }, [_c('b', [_vm._v("Оплата с мобильного")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@/assets/img/lk-mode-circle.svg"),
      "alt": "circle"
    }
  })]), _c('img', {
    staticClass: "_profile-payment-img",
    attrs: {
      "src": require("@/assets/img/lk-mode-mobile-grey.svg"),
      "alt": "mobile-grey"
    }
  }), _c('span', [_vm._v("Стоимость: 16р/день")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-payment-green"
  }, [_c('div', {
    staticClass: "_profile-payment-header"
  }, [_c('b', [_vm._v("Оплата с мобильного")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@/assets/img/lk-mode-circle-active.svg"),
      "alt": "circle-active"
    }
  })]), _c('img', {
    staticClass: "_profile-payment-img",
    attrs: {
      "src": require("@/assets/img/lk-mode-mobile-green.svg"),
      "alt": "mobile-green"
    }
  }), _c('span', [_vm._v("Стоимость: 16р/день")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-payment-grey"
  }, [_c('div', {
    staticClass: "_profile-payment-header"
  }, [_c('b', [_vm._v("Оплата"), _c('br'), _vm._v(" по карте")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@/assets/img/lk-mode-circle.svg"),
      "alt": "circle"
    }
  })]), _c('img', {
    staticClass: "_profile-payment-img",
    attrs: {
      "src": require("@/assets/img/lk-mode-credit-card-grey.svg"),
      "alt": "credit-card-grey"
    }
  }), _c('span', [_vm._v("Mastercard/VISA/МИР"), _c('br'), _vm._v("Стоимость: 269р/месяц")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-payment-green"
  }, [_c('div', {
    staticClass: "_profile-payment-header"
  }, [_c('b', [_vm._v("Оплата"), _c('br'), _vm._v(" по карте")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@/assets/img/lk-mode-circle-active.svg"),
      "alt": "circle-active"
    }
  })]), _c('img', {
    staticClass: "_profile-payment-img",
    attrs: {
      "src": require("@/assets/img/lk-mode-credit-card-green.svg"),
      "alt": "credit-card-green"
    }
  }), _c('span', [_vm._v("Mastercard/VISA/МИР"), _c('br'), _vm._v("Стоимость: 269р/месяц")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-mode-inner-success-card"
  }, [_c('img', {
    staticClass: "_profile-mode-inner-success-image",
    attrs: {
      "src": require("@/assets/img/password-change-success.svg"),
      "alt": "Финсайт"
    }
  }), _c('div', {
    staticClass: "_profile-mode-inner-success-title"
  }, [_vm._v(" Пароль успешно изменен! ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-page-mode-info"
  }, [_c('h3', {
    staticClass: "_profile-page-mode-title"
  }, [_vm._v("Изменить пароль")]), _c('p', {
    staticClass: "_profile-page-mode-text"
  }, [_vm._v("Задайте новый пароль не менее 6 символов")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-mode-inner-success-card"
  }, [_c('img', {
    staticClass: "_profile-mode-inner-success-image",
    attrs: {
      "src": require("@/assets/img/password-change-success.svg"),
      "alt": "Финсайт"
    }
  }), _c('div', {
    staticClass: "_profile-mode-inner-success-title"
  }, [_vm._v(" E-mail успешно изменен! ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-page-mode-info"
  }, [_c('h3', {
    staticClass: "_profile-page-mode-title"
  }, [_vm._v("Управление E-mail")]), _c('p', {
    staticClass: "_profile-page-mode-text"
  }, [_vm._v("Для просмотра писем перейдите в почту или добавьте свой e-mail ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "btn-go-to-mail"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/message-icon.svg"),
      "alt": "message"
    }
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v("Перейти в почту")]), _c('img', {
    staticClass: "_profile-nav-arr",
    attrs: {
      "src": require("@/assets/img/lk-menu-arrow.svg"),
      "alt": "arrow"
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-page-mode-info "
  }, [_c('h3', {
    staticClass: "_profile-page-mode-title"
  }, [_vm._v("Отключить услугу")]), _c('p', {
    staticClass: "_profile-page-mode-text"
  }, [_vm._v("В этом случае доступ к разделам приостановится")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-page-mode-confirm-title"
  }, [_vm._v(" Вы уверены, что хотите приостановить доступ "), _c('br'), _vm._v("к журналу? ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-page-mode-info"
  }, [_c('h3', {
    staticClass: "_profile-page-mode-title"
  }, [_vm._v("Отключить услугу")]), _c('p', {
    staticClass: "_profile-page-mode-text"
  }, [_vm._v("В этом случае доступ к разделам приостановится")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-page-mode-confirm-title"
  }, [_vm._v(" Вы уверены, что хотите приостановить доступ "), _c('br'), _vm._v("к инвестициям? ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-page-mode-info"
  }, [_c('h3', {
    staticClass: "_profile-page-mode-title"
  }, [_vm._v("Отключить все услуги")]), _c('p', {
    staticClass: "_profile-page-mode-text"
  }, [_vm._v("Будут отключены все активные подписки")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-page-mode-confirm-title"
  }, [_vm._v(" Вы уверены, что хотите приостановить доступ "), _c('br'), _vm._v("ко всем услугам? ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_profile-mode-inner-success-card"
  }, [_c('img', {
    staticClass: "_profile-mode-inner-success-image",
    attrs: {
      "src": require("@/assets/img/password-change-success.svg"),
      "alt": "Финсайт"
    }
  }), _c('div', {
    staticClass: "_profile-mode-inner-success-title"
  }, [_vm._v(" Услуга успешно отключена! ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_vm._v("Только для абонентов Теле2"), _c('br'), _vm._v("Стоимость: 12р / день")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_vm._v("Подписка активна"), _c('br'), _vm._v("Стоимость: 12р / день")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_vm._v("Mastercard/VISA/МИР"), _c('br'), _vm._v("Стоимость: 269р/месяц")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_vm._v("Подписка активна"), _c('br'), _vm._v("Стоимость: 269р/месяц")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "margin-bottom": "23px",
      "margin-top": "31px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/profile-img.svg"),
      "alt": "Финсайт"
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "payment-success-modal-text"
  }, [_vm._v(" Спасибо!"), _c('br'), _vm._v("Услуга успешно подключена ")]);
}]

export { render, staticRenderFns }